import { render } from "./ASEchipaNoastra.vue?vue&type=template&id=9c57e238"
import script from "./ASEchipaNoastra.vue?vue&type=script&lang=js"
export * from "./ASEchipaNoastra.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__